export const DICTIONARIES_UIDS = {
  ORDER_STEPS: 'order-steps',
  UNIT_TYPES: 'unit-types',
  CONTACT_TYPES: 'contact-type',
  STORE_CATEGORY_TYPES: 'store-category-types',
  USER_LOCATION_TYPES: 'user-location-type',
  ADDRESS2_TYPES: 'address2-type',
  ORDER_ITEM_STATUS: 'shopping-item-status',
};
